var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({directives:[{name:"wave",rawName:"v-wave",value:(_vm.ripple),expression:"ripple"}],class:[
		'custom-btn',
		_vm.variant ? `custom-btn--${_vm.variant}` : '',
		_vm.inverted ? 'custom-btn--inverted' : '',
		_vm.fullWidth ? 'w-full' : ''
	],attrs:{"aria-label":_vm.$attrs['aria-label'] || _vm.$attrs.title,"type":_vm.submit ? 'submit' : 'button'}},'button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }